import { render, staticRenderFns } from "./EditStudent.vue?vue&type=template&id=243841f1&scoped=true"
import script from "./EditStudent.vue?vue&type=script&lang=js"
export * from "./EditStudent.vue?vue&type=script&lang=js"
import style0 from "./EditStudent.vue?vue&type=style&index=0&id=243841f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243841f1",
  null
  
)

export default component.exports